const constant = {
  kakaoUrl: 'https://pf.kakao.com/_VTxfgn',
  instaUrl: 'https://www.instagram.com/residence_ohu_',
  email: 'residence.ohu@gmail.com'
};

export default constant;
